import { render } from "./test_management_user.vue?vue&type=template&id=05237c46&scoped=true"
import script from "./test_management_user.vue?vue&type=script&lang=js"
export * from "./test_management_user.vue?vue&type=script&lang=js"

import "./test_management_user.vue?vue&type=style&index=0&id=05237c46&scoped=true&lang=css"
import "./test_management_user.vue?vue&type=style&index=1&id=05237c46&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05237c46"]])

export default __exports__